import React from "react";

export default class AdElement extends React.Component<{}, {}> {

    googleInit: any = null;

    componentDidMount() {
        this.googleInit = setTimeout(() => {
            if (typeof window !== "undefined") {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        }, 300);
    }

    componentWillUnmount() {
        if (this.googleInit) {
            clearTimeout(this.googleInit);
        }
    }

    render() {
        return (<div className="text-center mt-4">
            {/*<Adsense*/}
            {/*	client="ca-pub-5770712839328791"*/}
            {/*	slot="9079729118"*/}
            {/*	format="fluid"*/}
            {/*	adTest={"on"}*/}
            {/*/>*/}
            <ins className="adsbygoogle"
                style={{ "display": "block" }}
                data-ad-client="ca-pub-5770712839328791"
                data-ad-slot="9079729118"
                data-adtest="on"
                data-ad-format="auto"
                data-full-width-responsive="true" />
        </div>);
    }
}
